document.addEventListener("DOMContentLoaded", function() {
  initWikiCategories();
  initTableOfContents();
  const sides = document.querySelectorAll('.category-open-d5');

  if (window.innerWidth < 768) {
    sides.forEach(side => side.classList.remove('category-open-d5'))
  }
  
  document.querySelectorAll('.d5-articles-list').forEach(e => {
    e.style.maxHeight = 'unset'
    e.style.opacity = 'unset'
  });
});

function initWikiCategories() {
  const mainContents = document.querySelectorAll(".wiki-layout-main-d5");
 
  mainContents.forEach(content => {
    const mediaElements = content.querySelectorAll(".wm-main-d5 img, .wm-main-d5 video");
    mediaElements.forEach((el, index) => {
      el.id = `media-${index}`;
    });
    
    const media = content.querySelectorAll("p img, p video")
    media.forEach(el => {
      const p = el.parentElement
      const mediaDetailDiv = document.createElement("div")
      mediaDetailDiv.classList.add("media-detail-d5")
      
      const mediaInfoDiv = document.createElement("div")
      mediaInfoDiv.classList.add("media-info-d5")
      
      const mediaInfoText = document.querySelector(`.media-info-text-d5#${el.id}`)
      if (mediaInfoText) {
        mediaInfoDiv.appendChild(mediaInfoText.cloneNode(true))
      }
      
      mediaDetailDiv.appendChild(el.cloneNode(true))
      mediaDetailDiv.appendChild(mediaInfoDiv)
      
      p.replaceChild(mediaDetailDiv, el)
      
      p.classList.add("media-wrapper-d5")
      const wrapper = document.createElement("span")
      wrapper.classList.add("text-wrapper-d5")

      const nodesToWrap = []
      Array.from(p.childNodes).forEach(node => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.classList.contains("media-detail-d5")
        ) {
        } else {
          nodesToWrap.push(node)
        }
      })

      if (nodesToWrap.length > 0) {
        p.insertBefore(wrapper, nodesToWrap[0])
        nodesToWrap.forEach(n => wrapper.appendChild(n))
      }
    })

    const menus = content.querySelectorAll('[d5-tb-menu]');
    menus.forEach(menu => {
      if (menu) {
        menu.addEventListener('click', () => {
          content.classList.toggle('category-open-d5');
        });
      }
    });
    
    document.body.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('.close-cat-d5');
      if (closeBtn) {
        content.classList.remove('category-open-d5');
      }
    });
  });
}

function initTableOfContents() {
  const CONTENT_SEL = ".wm-description-d5";
  const TOC_CONTAINER_SEL = ".d5-cate-d5";
  const HEADER_OFFSET_PX = 0;

  function slugify(text) {
    return text.toLowerCase().trim().replace(/[\s]+/g, "-").replace(/[^a-z0-9\-]/g, "");
  }

  function ensureUniqueId(base, used) {
    let id = base || "section";
    let i = 2;
    while (used.has(id) || document.getElementById(id)) {
      id = base + "-" + i++;
    }
    used.add(id);
    return id;
  }

  function makeLink(id, label, tocContainer, article) {
    const a = document.createElement("a");
    a.href = "#" + id;
    a.textContent = label;
    a.addEventListener("click", function(e) {
      e.preventDefault();
      const target = document.getElementById(id);
      if (!target) return;
      
      // Get the article container
      const articleToc = article.querySelector(TOC_CONTAINER_SEL);
      
      try {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        if (HEADER_OFFSET_PX) {
          setTimeout(() => {
            window.scrollTo({
              top: window.scrollY - HEADER_OFFSET_PX,
              behavior: "instant"
            });
          }, 250);
        }
      } catch (_) {
        const y = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET_PX;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
      
      // Update active state only in the current article's TOC
      articleToc.querySelectorAll("a.active").forEach(el => el.classList.remove("active"));
      a.classList.add("active");
    });
    return a;
  }

  function buildTOC() {
    const articles = document.querySelectorAll(".wiki-layout-main-d5");
    if (!articles.length) return;

    articles.forEach((article) => {
      const content = article.querySelector(CONTENT_SEL);
      const tocContainer = article.querySelector(TOC_CONTAINER_SEL);
      if (!content || !tocContainer) return;

      // Find FAQ and info sections with unique IDs based on article handle
      const faqSection = content.parentElement.querySelector('.wm-faqs-d5');
      const infoSection = content.parentElement.parentElement.querySelector('.wm-info-box-d5');

      const headings = Array.from(content.querySelectorAll("h2, h3"));
      if (!headings.length && !faqSection && !infoSection) {
        tocContainer.textContent = "";
        return;
      }

      tocContainer.style.setProperty("--toc-offset", HEADER_OFFSET_PX + "px");

      const used = new Set();
      headings.forEach(h => {
        if (!h.id) {
          const base = slugify(h.textContent) || "section";
          h.id = ensureUniqueId(base, used);
        } else {
          used.add(h.id);
        }
      });

      const topUl = document.createElement("ul");
      topUl.className = "wc-toc";

      let currentLi = null;
      let currentSubUl = null;

      headings.forEach(h => {
        const a = makeLink(h.id, h.textContent, tocContainer, article);
        const li = document.createElement("li");
        li.appendChild(a);

        if (h.tagName === "H2") {
          currentLi = li;
          currentSubUl = null;
          topUl.appendChild(li);
        } else {
          if (!currentLi) {
            topUl.appendChild(li);
            return;
          }
          if (!currentSubUl) {
            currentSubUl = document.createElement("ul");
            currentLi.appendChild(currentSubUl);
          }
          currentSubUl.appendChild(li);
        }
      });

      function appendStatic(section, label) {
        if (!section || !section.id) return false;
        const id = section.id;
        if (topUl.querySelector(`a[href="#${CSS.escape(id)}"]`)) return false;
        const a = makeLink(id, label, tocContainer, article);
        const li = document.createElement("li");
        li.appendChild(a);
        topUl.appendChild(li);
        return true;
      }

      // Add FAQ if exists, otherwise add Info Box
      if (!appendStatic(faqSection, "FAQ")) {
        appendStatic(infoSection, "Information");
      } else {
        appendStatic(infoSection, "Information");
      }

      tocContainer.innerHTML = "";
      tocContainer.appendChild(topUl);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const id = entry.target.id;
          const link = tocContainer.querySelector(`a[href="#${CSS.escape(id)}"]`);
          if (link) {
            if (entry.isIntersecting) {
              tocContainer.querySelectorAll("a.active").forEach(el => el.classList.remove("active"));
              link.classList.add("active");
            }
          }
        });
      }, { rootMargin: `-${HEADER_OFFSET_PX + 10}px 0px -70% 0px`, threshold: 0.01 });

      headings.forEach(h => observer.observe(h));
      if (faqSection) observer.observe(faqSection);
      if (infoSection) observer.observe(infoSection);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", buildTOC);
  } else {
    buildTOC();
  }
  window.addEventListener("load", buildTOC);
  window.rebuildD5Toc = buildTOC;
}